// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-template-modal-v6069j .semi-modal{width:960px!important}.project-template-modal-v6069j .semi-modal-content{padding-bottom:0!important;padding-left:0!important;padding-right:0!important}.project-template-modal-v6069j .semi-modal-header{padding-left:24px;padding-right:24px}.error-empty-o7CBwa{padding:124px 0}.error-empty-o7CBwa .semi-empty-content{margin-top:8px}.error-empty-o7CBwa .semi-empty-footer{justify-content:center;margin-top:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"project-template-modal": `project-template-modal-v6069j`,
	"projectTemplateModal": `project-template-modal-v6069j`,
	"error-empty": `error-empty-o7CBwa`,
	"errorEmpty": `error-empty-o7CBwa`
};
export default ___CSS_LOADER_EXPORT___;
